import { createFileRoute, useRouter } from '@tanstack/react-router'
import { assetPath } from '@/utils/assetPath'
import { GlossyButton } from '@/components/shared/atoms/GlossyButton'
import { useOnboardingStore } from '@/stores/onboarding'
import { FadeInUp } from '@/components/shared/atoms/FadeInUp'
import { useEffect } from 'react'

export const Route = createFileRoute('/(onboarding)/(auth)/onboarding')({
    component: OnboardingScreen,
})

function OnboardingScreen() {
    const router = useRouter()
    const { resetRegistrationData } = useOnboardingStore()

    // Reset registration data when landing on the main onboarding page
    useEffect(() => {
        resetRegistrationData()
    }, [resetRegistrationData])

    const handleLogin = () => {
        router.navigate({ to: '/login' })
    }

    const handleCreateAccount = () => {
        router.navigate({ to: '/register' })
    }

    // Only render the welcome screen here
    return (
        <section className="relative z-10 flex min-h-dvh flex-col pt-safe">
            <div className="flex justify-center px-2 pt-3">
                <img
                    alt="logo-red"
                    src={assetPath('logo/logo-red.svg')}
                    className="h-full w-full md:mt-12 md:h-[100px] md:w-[440px]"
                />
            </div>

            <div className="flex flex-1 flex-col" />

            <FadeInUp delay={0.3} className="mb-6 px-2">
                <GlossyButton
                    onClick={handleLogin}
                    variant="ghost"
                    className="w-full rounded-xl bg-white/20 px-4 py-[14px] text-sm font-medium text-white backdrop-blur-md"
                >
                    Log in
                </GlossyButton>
                <FadeInUp delay={0.6}>
                    <GlossyButton
                        onClick={handleCreateAccount}
                        className="mt-2 w-full rounded-xl py-[14px] text-sm"
                    >
                        Create an account
                    </GlossyButton>
                </FadeInUp>
            </FadeInUp>
        </section>
    )
}
